import "./PersonalInfo.css";
import React, { useContext } from "react";
import FormState from "../context/FormState";
import { uploadWorkInformation } from "../helpers/firebase";
import styles from "./personalInfo.module.css";
import logo from "../../../assets/img/logo.png";
import Profile_img from "../../../assets/img/Profile_img.png";
function WorkInfo(props) {
  const ctx = useContext(FormState);
  const submitHandler = () => {
    uploadWorkInformation(
      ctx.headline,
      ctx.position,
      ctx.company,
      ctx.designation,
      ctx.workFrom,
      ctx.workTo,
      ctx.location
    );
  };
  return (
    <React.Fragment>
     {/* <Header></Header> */}

     <div className={styles.container}>
       <div className={styles.left}>
         <div className={styles.imageContainer}>
           <img src={logo} alt="" />

           <div className={styles.logoDesc}>
             <p>VIT AP UNIVERSITY</p>
             <p className={styles.smallDes}>Alumni Association</p>
           </div>
         </div>

         {/* image kindha */}
         <div className={styles.sideNav}>
           <div className={styles.navItem}>
             <div className={styles.num}>1</div>
             <div className={styles.pInfo}>
               <p className={styles.pBigInfo}>Personal Information</p>
               <p className={styles.psmallInfo}>Personal Profile Details</p>
             </div>
           </div>

           <div className={styles.navItem}>
             <div className={styles.num}>2</div>

             <div className={styles.pInfo}>
               <p className={styles.pBigInfo}>Educational Information</p>
               <p className={styles.psmallInfo}>Courses/degrees pursued</p>
             </div>
           </div>

           <div className={styles.navItem}>
             <div className={styles.num}>3</div>

             <div className={styles.pInfo}>
               <p className={styles.pBigInfo}>Contact Details</p>
               <p className={styles.psmallInfo}>Location and contact</p>
             </div>
           </div>

           <div className={styles.navItem}>
             <div className={styles.num}>4</div>

             <div className={styles.pInfo}>
               <p className={styles.pBigInfo}>Work Details</p>
               <p className={styles.psmallInfo}>Professional Details</p>
             </div>
           </div>
         </div>
       </div>

       <div className={styles.right}>
         <div className={styles.profile}>
           <div className={styles.userInfo}>
             <p className={styles.username}>Mervin Joseph</p>
             <p>VIT AP University</p>
           </div>
           <img
             src={Profile_img}
             alt="Profile Image"
             className={styles.profileImage}
           />
         </div>

         <h1>Work Details</h1>

         <table className={styles.rightDesc}>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
             <td><p>Professional Headline</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Current Position</p></td>
             <td className={styles.radionCon}>
              <input type="radio" /> Student
              <input type="radio" /> Employee
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Company Name</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Position/Designation</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Time Period</p></td>
             <td className={styles.radionCon}>
               <input type="text" placeholder="From"/> to 
               <input type="text" placeholder="To"/>
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Location</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
         </table>

         {/* buttons */}
         <div className={styles.buttons}> 
            <button className={styles.btn} onClick={()=>props.setStep("4")}>Back</button>
           <button className={styles.btn}>Submit</button>
         </div>
       </div>
     </div>
     </React.Fragment>
  );
}
export default WorkInfo;
